import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import './ServiceDown.css';
import maintenanceImage from '../../assets/images/UnderMaintenance.jpg'; // Ensure the path is correct

const ServiceDown = () => {
  const { service } = useParams(); // Get the service name from URL params
  const navigate = useNavigate();

  // Map service names to user-friendly display names and dashboard routes
  const serviceInfo = {
    auth: { name: 'Authentication Service', dashboard: '/login' },
    user: { name: 'User Service', dashboard: '/login' },
    admin: { name: 'Admin Service', dashboard: '/admin' },
    candidate: { name: 'Candidate Service', dashboard: '/candidate' },
    employee: { name: 'Employee Service', dashboard: '/employee' },
  };

  // Default to a generic service if not found
  const displayService = serviceInfo[service] || { name: 'Service', dashboard: '/dashboard' };

  return (
    <div className="service-down-container">
      <div className="image-box">
        <img src={maintenanceImage} alt="Service Under Maintenance" className="maintenance-image" />
        <div className="message">
          <h1>🚧 {displayService.name} Down</h1>
          <p>We’re currently performing some maintenance on the {displayService.name}.<br />Please check back shortly.</p>
          <button onClick={() => navigate(displayService.dashboard)}>
            Back to {displayService.name.includes('Authentication') ? 'Login' : 'Dashboard'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceDown;